import React, {ReactElement} from 'react';
import { LoaderComponent, HightLight } from './style';

export default function Loader(): ReactElement {
    return (
        <LoaderComponent>
            <HightLight></HightLight>
        </LoaderComponent>
    );
}